module.exports = __webpack_public_path__ + "static/img/idCarP.5c1f6dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idCarP.png
// module id = 2rLY
// module chunks = 0